import { QueryClientProvider } from "@tanstack/react-query";
import * as React from "react";

import { Toaster } from "@/components/ui/toaster";
import { LocaleProvider } from "@/features/i18n/locale-provider";
import { createQueryClient } from "./query-client";

export function AppProviders({ children }: { children: React.ReactNode }) {
  // One client per app instance — created lazily so HMR doesn't recreate it.
  const [queryClient] = React.useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <LocaleProvider>
        {children}
        <Toaster />
      </LocaleProvider>
    </QueryClientProvider>
  );
}
